// extracted by mini-css-extract-plugin
export default {"outerDiv":"login-page_outerDiv__3tHqQ","yuvaImg":"login-page_yuvaImg__A8hsF","dualBannerWrap":"login-page_dualBannerWrap__lQmxQ"};